export default {
    general: {
        add:        'Dodaj',
        edit:       'Uredi',
        cancel:     'Prekliči',
        back:       'Nazaj',
        save:       'Shrani',
        delete:     'Izbriši',
        close:      'Zapri',
        search:     'Išči',
        loading:    'Nalaganje...',
        yes:        'Da',
        no:         'Ne',
        actions:    'Dejanja',
        name:       'Ime',
        color:      'Barva',
        or:         'ali',
        today:      'Danes',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Nimate dovoljenja',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri urejanju',
        on_delete:     'Napaka pri brisanju',
    },
    success: {
        add:    'Uspešno dodano',
        edit:   'Uspešno posodobljeno',
        delete: 'Uspešno izbrisano',
    },
    auth: {
        login:    'Prijava',
        logout:   'Odjava',
        username: 'Uporabniško ime',
        password: 'Geslo',
    },
    recipe: {
        recipes:         'Recepti',
        recipe:          'Recept',
        add:             'Dodaj recept',
        edit:            'Uredi recept',
        title:           'Naslov',
        servings:        'Porcije',
        prep_time:       'Skupni čas (min)',
        cook_time:       'Čas kuhanja (min)',
        ingredients:     'Sestavine',
        instructions:    'Navodila',
        notes:           'Opombe',
        tags:            'Oznake',
        nutrition:       'Hranilne vrednosti',
        calories:        'Kalorije (kcal)',
        protein:         'Beljakovine (g)',
        carbs:           'Ogljikovi hidrati (g)',
        fat:             'Maščobe (g)',
        images:          'Slike',
        add_image:       'Dodaj sliko',
        scale:           'Prilagodi porcije',
        can_make:        'Kaj lahko skuham?',
        tolerance:       'Toleranca manjkajočih',
        must_have_only:  'Samo obvezne sestavine',
        enter_nutrition: 'Vnesite hranilne vrednosti (na porcijo)',
        min_calories:    'Min. kalorije',
        max_calories:    'Maks. kalorije',
        ingredient:      'Sestavina',
        quantity:        'Količina',
        unit:            'Enota',
        importance:      'Pomembnost',
        must_have:       'Obvezno',
        nice_to_have:    'Po želji',
        missing:         'Manjka',
        add_step:        'Dodaj korak',
        cover_image:     'Naslovna slika',
        by:              'Dodal/a',
        edited_by:       'Zadnje urejal/a',
        total_time:      'Skupni čas',
        min:             'min',
        per_serving:     'na porcijo',
    },
    ingredient: {
        ingredients:  'Sestavine',
        ingredient:   'Sestavina',
        add:          'Dodaj sestavino',
        edit:         'Uredi sestavino',
        merge:        'Združi sestavini',
        merge_source: 'Izvorna sestavina',
        merge_target: 'Ciljna sestavina',
        default_unit: 'Privzeta enota',
        category:     'Kategorija',
        used_in:      'Uporabljena v receptih',
        create_new:   'Nova sestavina',
        categories: {
            produce: 'Zelenjava in sadje',
            dairy:   'Mlečni izdelki',
            pantry:  'Shramba',
            spices:  'Začimbe',
            meat:    'Meso in ribe',
            bakery:  'Pekarna',
            other:   'Drugo',
        },
    },
    tag: {
        tags: 'Oznake',
        tag:  'Oznaka',
        add:  'Dodaj oznako',
        edit: 'Uredi oznako',
    },
    meal_plan: {
        meal_plan:       'Jedilnik',
        add_meal:        'Dodaj obrok',
        edit_meal:       'Uredi obrok',
        slot:            'Obrok',
        breakfast:       'Zajtrk',
        lunch:           'Kosilo',
        dinner:          'Večerja',
        planned_servings: 'Načrtovane porcije',
        free_text:       'Prosto besedilo (npr. ostanki, zunaj)',
        or_recipe:       'ali izberi recept',
    },
    shopping: {
        shopping_list:   'Nakupovalni seznam',
        generate:        'Generiraj seznam',
        from:            'Od',
        to:              'Do',
        check_all:       'Označi vse',
        uncheck_all:     'Odznači vse',
        empty:           'Nobenih sestavin za izbrano obdobje',
    },
    nav: {
        recipes:     'Recepti',
        ingredients: 'Sestavine',
        tags:        'Oznake',
        meal_plan:   'Jedilnik',
        shopping:    'Nakupovalni seznam',
        profile:     'Profil',
        users:       'Uporabniki',
    },
    user: {
        users:        'Uporabniki',
        add:          'Dodaj uporabnika',
        edit:         'Uredi uporabnika',
        name:         'Ime',
        username:     'Uporabniško ime',
        password:     'Geslo',
        new_password: 'Novo geslo (pusti prazno za brez spremembe)',
    },
    profile: {
        profile:          'Profil',
        change_password:  'Spremeni geslo',
        current_password: 'Trenutno geslo',
        new_password:     'Novo geslo',
        confirm_password: 'Potrdi novo geslo',
        passwords_no_match: 'Gesli se ne ujemata',
    },
}
